import React from 'react';
import { Loader } from '../../../../../../../common/components';

import PremiumTable from './components/PremiumTable/PremiumTable';
import { Field } from 'redux-form';
import { required } from 'redux-form-validators';
import AdditionalFieldsContainer from './components/AdditionalFieldsContainer/AdditionalFieldsContainer';

const QuoteTab = ({ calculatedPremiums, isSaving, productId, productCode }) => {
  return (
    <div className={'pa-tab-content'}>
      <AdditionalFieldsContainer productId={productId} />
      {isSaving && <Loader />}
      {!isSaving && calculatedPremiums && (
        <>
          <Field
            name={'data.relationships.schemes.data'}
            calculatedPremiums={calculatedPremiums}
            component={PremiumTable}
            productCode={productCode}
            validate={required({ msg: 'Please select a least on scheme to continue' })}
          />
        </>
      )}
    </div>
  );
};

export default QuoteTab;
